import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import { Http } from "@status/codes";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { Response } from "@/shared/models/Response";
import { CampusService } from "./services/CampusService";
import {
  CAMPUS_ACCESS,
  CAMPUS_CONSTANTS,
  CAMPUS_FILTERS
} from "./constants/CampusConstants";
import { CampusPagination } from "./models/CampusPagination";
import { CampusModel } from "./models/CampusModel";
import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import {
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Utils } from "@/shared/utils/utils";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import store from "@/store";
import { SearchContextModal } from "../../shared/models/SearchContextModal";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import lodash from "lodash";
import { AxiosError } from "axios";
import { CampusQuery } from "./models/CampusQuery";

@Component({
  name: "Campus",
  components: {
    EmptyState,
    ScrollBottom,
    ModalTemplate,
    ListItem,
    GenericSearchBar
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Campus extends Vue {
  @Inject() campusService!: CampusService;

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  PAGE_TITLE = CAMPUS_CONSTANTS.PAGE_CAMPUS_TITLE;
  ADD_CAMPUS_BTN = CAMPUS_CONSTANTS.BUTTON.ADD_CAMPUS_TEXT;
  OPERATIONS: string[] = [];
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;

  observationModalTitle = CAMPUS_CONSTANTS.CAMPUS_REASON_MODAL.TITLE;
  observationModalText = CAMPUS_CONSTANTS.CAMPUS_REASON_MODAL.MESSAGE;
  modalVoidedData = { ...FORM_MESSAGES.DESACTIVED_MODAL };

  showCardsContainer = false;
  loadingData = false;
  campusList!: CampusModel[];
  dialogObservation = false;
  dataCampus!: Response<CampusPagination>;
  idReference = "";
  canSearch = true;

  SEARCH_CAMPUS_KEY = NAME_FINDERS.CAMPUS;

  filterItems: {
    name?: string[];
    state?: string[];
  } = {};
  filterArray: Filter[] = lodash.cloneDeep(CAMPUS_FILTERS) as Filter[];

  actionMode = "";
  itemState = "";
  dialogState = false;

  dataToMainView!: MenuDataStructure;
  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleContextPanel: Function = () => {};
  showButtonCreate = false;

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH &&
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL
    ) {
      this.callbackHandleContextPanel = this.dataToMainView.data;
    }
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    this.showButtonCreate = this.OPERATIONS.includes(
      LIST_DATA_EVENTS.SAVE_DATA
    );
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  emitModalInitializer() {
    const searchContext: SearchContextModal = {
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.CAMPUS
    };
    const data = {
      ...searchContext
    };
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL, data);
  }

  mounted() {
    this.modalVoidedData.TEXT = this.modalVoidedData.TEXT.replace(
      FORM_MESSAGES.COMPONENT,
      COMPONENT_NAME_MODAL.CAMPUS
    );

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.CAMPUS
    );

    this.searchData(true);
    this.emitModalInitializer();
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editCampus(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteCampus(itemId);
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateCampus(itemId, STATE.ACTIVE);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateCampus(itemId, STATE.INACTIVE);
        break;
    }
  }

  editCampus(campusId: string) {
    NavigationService.navigateTo(SystemView.SAVE_CAMPUS, { id: campusId });
  }

  async searchData(data: any) {
    this.loadingData = true;
    this.showCardsContainer = false;
    this.canSearch = false;
    this.campusList = [];

    delete data["mainFilterKey"];

    this.filterItems = { ...data };

    this.dataCampus = await this.getDataByFilter();

    if (
      this.dataCampus.code === Http.Found &&
      this.dataCampus.data !== undefined
    ) {
      this.campusList = this.dataCampus.data.data;
      this.idReference = this.dataCampus.data.docref;
      this.showCardsContainer = true;
      this.canSearch = true;
    } else {
      if (this.dataCampus.code === Http.NotFound) {
        Snackbar.popInfo(this.dataCampus.message);
      } else {
        Snackbar.popError(this.dataCampus.message);
      }
    }

    this.loadingData = false;
  }

  async getDataByFilter(
    loadPages?: boolean
  ): Promise<Response<CampusPagination>> {
    try {
      const filterQuery: CampusQuery = {
        state: [STATE.ACTIVE]
      };

      if (this.filterItems.name) filterQuery.name = this.filterItems.name[0];

      if (this.filterItems.state) filterQuery.state = this.filterItems.state;

      if (loadPages) filterQuery.docref = this.idReference;

      const responseData = await this.campusService.getCampusByFilter(
        filterQuery
      );
      return responseData;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        const RESPONSE_ACCESS_ERROR: Response<CampusPagination> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + CAMPUS_ACCESS.GET
        };
        return RESPONSE_ACCESS_ERROR;
      } else {
        const RESPONSE_ERROR: Response<CampusPagination> = {
          code: Http.BadRequest,
          message: FORM_MESSAGES.REQUEST_FAILED
        };
        return RESPONSE_ERROR;
      }
    }
  }

  async updateStateCampus(campusId: string, state: string) {
    try {
      const responseData = await this.campusService.updateStateCampus(
        campusId,
        state
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchData(true);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CAMPUS_ACCESS.PUT);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteCampus(id: string) {
    try {
      const responseData = await this.campusService.deleteCampus(id);

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(CAMPUS_CONSTANTS.DIALOG_MESSAGE.CAMPUS_DELETED);
        await this.searchData(true);
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(CAMPUS_CONSTANTS.DIALOG_MESSAGE.CAMPUS_USED);
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + CAMPUS_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async onBottom() {
    if (this.canSearch && !this.loadingData) {
      this.loadingData = true;
      if (!this.campusList) this.campusList = [];
      this.dataCampus = await this.getDataByFilter(true);

      if (
        this.dataCampus.code === Http.Found &&
        this.dataCampus.data !== undefined
      ) {
        if (this.dataCampus.data.docref !== this.idReference) {
          this.campusList = this.campusList.concat(this.dataCampus.data.data);
          this.idReference = this.dataCampus.data.docref;
          this.showCardsContainer = true;
        } else {
          this.canSearch = false;
        }
      } else if (this.dataCampus.code === Http.NotFound) {
        this.canSearch = false;
      } else {
        Snackbar.popError(this.dataCampus.message);
        this.canSearch = false;
      }

      this.loadingData = false;
    }
  }

  showCrudSave() {
    NavigationService.navigateTo(SystemView.SAVE_CAMPUS);
  }
}
